export { errorMessage, formatCount, pageWindow, personName, RamoMark } from '../../customers/common/customer-common'
export { formatSlashDateTime } from '../../../utils/dates'

export const AUTOMATIONS_PATH = '/automatizaciones'
export const AUTOMATIONS_HELP_URL = 'https://appdalala.blogspot.com/2022/05/importacion-automatica.html'

export const automationPath = (id: number) => `${AUTOMATIONS_PATH}/${id}`
